import React from "react";
import CustomNavbarClients from "./components/navBarClients/CustomNavbarClients";
import { Container } from "react-bootstrap";
import ClientMenuBar from "./components/ClientMenuBar";
import PromotionBanner from "./components/promotions/PromotionBanner";
import NewestProducts from "./components/newestProducts/NewestProducts";
import TrendingProducts from "./components/trendingProducts/TrendingProducts";
import Footer from "./components/Footer";

const MainPage: React.FC = () => {
  return (
    <>
      <CustomNavbarClients />
      <ClientMenuBar />

      {/* Banner de envío gratis */}
      <div
        style={{
          backgroundColor: "#FF3B3B",
          color: "white",
          textAlign: "center",
          fontSize: "24px",
          fontWeight: "bold",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          marginBottom: "0.5rem",
          overflow: "hidden",
          position: "relative",
          height: "60px",
          display: "flex",
          alignItems: "center",
        }}
      >
        <div
          style={{
            animation: "marquee 20s linear infinite",
            whiteSpace: "nowrap",
            position: "absolute",
            display: "flex",
            width: "max-content",
          }}
        >
          <span style={{ marginRight: "50px" }}>
            Envío gratis en toda la república en la compra de 3 o más artículos!
          </span>
          <span style={{ marginRight: "50px" }}>
            Envío gratis en toda la república en la compra de 3 o más artículos!
          </span>
          <span style={{ marginRight: "50px" }}>
            Envío gratis en toda la república en la compra de 3 o más artículos!
          </span>
          <span style={{ marginRight: "50px" }}>
            Envío gratis en toda la república en la compra de 3 o más artículos!
          </span>
          <span style={{ marginRight: "50px" }}>
            Envío gratis en toda la república en la compra de 3 o más artículos!
          </span>
        </div>
      </div>

      <style>
        {`
          @keyframes marquee {
            0% {
              transform: translateX(0);
            }
            100% {
              transform: translateX(-33.33%);
            }
          }
        `}
      </style>

      <Container fluid className="p-0" id="main-container">
        <PromotionBanner />
        <NewestProducts from="main" />
        <TrendingProducts />
        <Footer />
      </Container>
    </>
  );
};

export default MainPage;
